// eslint-disable-next-line import/no-mutable-exports, @typescript-eslint/ban-types
const firebaseConfig: Object = {
  apiKey: 'AIzaSyBzeoM-0mE5KeB-yVLccC7Wc03YnZGd1-s',
  authDomain: 'voypost-352213.firebaseapp.com',
  projectId: 'voypost-352213',
  storageBucket: 'voypost-352213.appspot.com',
  messagingSenderId: '122717601477',
  appId: '1:122717601477:web: d46f8d6b6ad047cbafbaac',
  measurementId: 'xxx',
};

export default firebaseConfig;
